export function navigateBackwardToPage(stepNum, prevPage, setStepNum, setActivePageName) {
	let copyCurIndex = stepNum;
	copyCurIndex -= 1;
	setStepNum(copyCurIndex);
	setActivePageName(prevPage);
}

export function navigateForwardToPage(stepNum, nextPage, setStepNum, setActivePageName) {
	let copyCurIndex = stepNum;
	copyCurIndex += 1;
	setStepNum(copyCurIndex);
	setActivePageName(nextPage);
}

export function navigateToNextSection(
	nextSectionKey,
	setActiveSectionKey,
	setActivePageName,
	setStepNum,
) {
	setActiveSectionKey(nextSectionKey);
	setStepNum(1);
	const kickOffPageName = `${nextSectionKey}KickOffPage`;
	setActivePageName(kickOffPageName);
}
